import script from "./LogoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoIcon.vue?vue&type=script&setup=true&lang=js"

import "./LogoIcon.vue?vue&type=style&index=0&id=7bbc3a3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbc3a3f"]])

export default __exports__